import { getTestSharedConfig } from './getTestSharedConfig'

import type { ClientConfig } from '@ngb-frontend/shared/types'

export const getTestClientConfig = (): ClientConfig => ({
  ...getTestSharedConfig(),
  onetrust: '',
  onetrustNFFleet: '',
  google: {
    maps: '12345',
    tagManager: '',
  },
  features: {
    driverCourtesy: true,
    eligibilityCheck: false,
  },
  hotjarConfig: {
    id: '',
    version: 6,
  },
})
